import React from "react";
import { NewDynamicTab } from "../../../components/Page";
import { JvvnlOverviewMetric } from "../../../config/DefaultDates";
import { JvvnlTitle, TabSwitcher } from "../Jvnnl_Dashboard";
import LoadMapIndex from "./LoadMapIndex";

const LoadMap = () => {
  return (
    <NewDynamicTab
      // headerPrefixComponent={<TabSwitcher />}
      defaultDates={JvvnlOverviewMetric}
      header="Load Map"
      showTabs={false}
      middleComponent={<JvvnlTitle />}
      tabs={{
        Metric: <LoadMapIndex />,
      }}
    />
  );
};

export default LoadMap;
